import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { NgSelectComponent } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { forkJoin } from "rxjs";
import { CompanyModaleComponent } from "../company-modal/company-modal.component";
import { Organization } from "@shared/models/organization";
import { Country } from "@shared/models/country";
import { Company } from "@shared/models/company";
import { ConfirmDialogComponent } from "@shared/components/confirm-dialog/confirm-dialog.component";
import { CompanyService } from "../../services/company.service";

@Component({
    standalone: true,
    selector: 'app-company',
    templateUrl: './company.component.html',
    styleUrls: ['./company.component.scss'],
    imports: [CommonModule, FormsModule,MatIconModule, TranslateModule, AngularSvgIconModule,NgSelectComponent],
})
export class CompanyComponent{
    @Input() organizations : Organization[] = [];
    @Input() countries : Country[] = [];
    @Output() selectedUserId = new EventEmitter<string>();
    expandedRowIndex: number | null = null;
    companies: Company[] = [];
    filteredCompanies: Company[] = [];
    selectedCompany: Company | null = null;
    constructor(private dialogConfirme: MatDialog, private companyService: CompanyService
    ) { }
        ngOnInit(): void {
            forkJoin({
                companies: this.companyService.getCompanies(),
            }).subscribe(({ companies }) => {
              this.companies = [...companies].map(company => ({
                ...company,
                userName: [...company.userName].sort((a, b) => a.name.localeCompare(b.name))
            }));
              this.filteredCompanies = [...this.companies];
            });
          }
          toggleRowDetails(index: number): void {
            this.expandedRowIndex = this.expandedRowIndex === index ? null : index;
        }
        onUserClick(userId: string): void {
            this.selectedUserId.emit(userId);
          }
    
          onCompanySelect(selectedCompany: Company): void {
            if (selectedCompany && selectedCompany.id) {
              this.filteredCompanies = this.companies.filter(company => company.id === selectedCompany.id);
            } else {
              this.filteredCompanies = [...this.companies];
            }
          }
         
        getCountryName(countryId: number): string {
            const country = this.countries.find(country => country.paysId === countryId);
            return country ? country.nomEn : '';
        }
        getOrganizationName(orgId: number): string {
            const organization = this.organizations.find(org => org.orgId === orgId);
            return organization ? organization.name : '';
        }
      openPopupCompany(company : Company): void {
                const dialogRef = this.dialogConfirme.open(CompanyModaleComponent,
                  {
                    data: { isNew: company?.id ? false : true, company:company , organizations : this.organizations, countries : this.countries },
                    enterAnimationDuration: '0ms',
                  },);
                dialogRef.afterClosed().subscribe(() => {
                    this.companyService.getCompanies().subscribe((result) => {
                        this.companies = result;
                        this.filteredCompanies = [...this.companies];
                        this.selectedCompany = null;
                    })
                });
              }
        deleteCompany(companyId: number): void {
            this.companyService.deleteCompany(companyId).subscribe(() => {
                this.companyService.getCompanies().subscribe((result) => {
                    this.companies = result;
                    this.filteredCompanies = [...this.companies];
                    this.selectedCompany = null;
                })
            });
        }      
          onDelete(companyId: number) {
            const dialogRef = this.dialogConfirme.open(ConfirmDialogComponent, {
              enterAnimationDuration: '0ms',
              data: { title: 'Delete Company', message: 'Would you like to delete this company ?' },
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                this.deleteCompany(companyId);
              }
            });
          }  
}